import {
  A4_FREQUENCY_HZ,
  A4_MIDI_NOTE,
} from "@/constants/pitchCorrection/pitchReference";

export const semitonesToFrequency = (
  semitones: number,
  referenceFrequency?: number,
  referenceMidi?: number
) => {
  const resolvedReferenceFrequency = referenceFrequency ?? A4_FREQUENCY_HZ;
  const resolvedReferenceMidi = referenceMidi ?? A4_MIDI_NOTE;
  return (
    resolvedReferenceFrequency *
    Math.pow(2, (semitones - resolvedReferenceMidi) / 12)
  );
};
